import { JSX } from 'react'

import { InfoIcon } from 'lucide-react'

import { SplitsLink } from '~/components/Link'
import { Tooltip } from '~/components/component-library'
import { cn } from '~/utils/tailwind-utils'

export function InputRow({
  className,
  label,
  input,
  tooltip,
  link,
  optional = false,
}: {
  className?: string
  label: string | JSX.Element
  input: JSX.Element
  tooltip?: string
  link?: string
  optional?: boolean
}): JSX.Element {
  return (
    <div className={cn('space-y-2 text-base', className)}>
      <div className="flex items-center gap-2">
        {tooltip ? (
          <Tooltip
            triggerClassName="relative flex items-center"
            content={
              <div className="max-w-[200px] text-center">
                {tooltip}
                {link && (
                  <SplitsLink
                    path={link}
                    target="tab"
                    className="pl-1 underline"
                  >
                    Learn more
                  </SplitsLink>
                )}
              </div>
            }
          >
            <>
              <div className="w-full text-xs font-medium text-primary md:text-sm">
                {label}
              </div>
              <InfoIcon className="ml-1 hidden h-3 w-3 flex-shrink-0 text-secondary transition md:flex" />
            </>
          </Tooltip>
        ) : (
          <div className="w-full text-xs font-medium text-primary md:text-sm">
            {label}
          </div>
        )}
        {optional && (
          <span className="text-sm font-normal text-secondary">Optional</span>
        )}
      </div>
      <div>{input}</div>
    </div>
  )
}
